import React from 'react';
import { FiUser, FiLogOut } from 'react-icons/fi';
import './Header.css';
import { removeToken, isAuthenticated } from '../utils/auth';

const Header = ({ user, onLoginClick, onLogout, onPIProfileClick }) => {
  const handleLogout = () => {
    removeToken();
    if (onLogout) onLogout();
  };

  // When logged in with sidebar, header is just a thin top bar with user info
  if (isAuthenticated() && user) {
    return (
      <header className="header header--minimal">
        <div className="header-content">
          <div className="header-left" />
          <div className="header-right">
            <div
              className="user-info user-info--clickable"
              onClick={onPIProfileClick || undefined}
              title="PI Profile"
            >
              <FiUser className="user-icon" />
              <span className="username">{user.display_name || user.username}</span>
            </div>
            <button className="header-button logout-button" onClick={handleLogout} title="Logout">
              <FiLogOut />
            </button>
          </div>
        </div>
      </header>
    );
  }

  // Logged out — show login button
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="logo">
            <span className="logo-icon">🔬</span>
            Mnevia
          </h1>
          <p className="tagline">Research Intelligence Platform</p>
        </div>
        <div className="header-right">
          <button className="header-button login-button" onClick={onLoginClick}>
            <FiUser /><span>Login</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
